import { cn } from '@/utils/tailwind'

export const Ringing = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMidYMid meet"
      width="220"
      height="220"
      viewBox="0 0 220 220"
      className={cn('text-primary mx-auto h-40 w-full', className)}
    >
      <defs>
        <animate
          repeatCount="indefinite"
          dur="2.8s"
          begin="0s"
          xlinkHref="#_R_G_L_3_G_D_0_P_0"
          fill="freeze"
          attributeName="stroke-width"
          from="5"
          to="0"
          keyTimes="0;0.5428571;0.7142857;0.9;1"
          values="5;5;1;0;0"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="2.8s"
          begin="0s"
          xlinkHref="#_R_G_L_3_G"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="0"
          keyTimes="0;0.6142857;0.9;1"
          values="1;1;0;0"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="2.8s"
          begin="0s"
          xlinkHref="#_R_G_L_3_G"
          fill="freeze"
          attributeName="transform"
          from="0 0"
          to="4.6000000000000005 4.6000000000000005"
          type="scale"
          additive="sum"
          keyTimes="0;0.1857143;0.9;1"
          values="0 0;0 0;4.6000000000000005 4.6000000000000005;4.6000000000000005 4.6000000000000005"
          keySplines="0.001 0 0.227 0.829;0.001 0 0.227 0.829;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="2.8s"
          begin="0s"
          xlinkHref="#_R_G_L_3_G"
          fill="freeze"
          attributeName="transform"
          from="17.537 -16.537"
          to="17.537 -16.537"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="17.537 -16.537;17.537 -16.537"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="2.8s"
          begin="0s"
          xlinkHref="#_R_G_L_3_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.1857143;0.1857157;0.9;0.9;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="2.8s"
          begin="0s"
          xlinkHref="#_R_G_L_2_G_D_0_P_0"
          fill="freeze"
          attributeName="stroke-width"
          from="5"
          to="0"
          keyTimes="0;0.3571429;0.5285714;0.7142857;1"
          values="5;5;1;0;0"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="2.8s"
          begin="0s"
          xlinkHref="#_R_G_L_2_G"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="0"
          keyTimes="0;0.4285714;0.7142857;1"
          values="1;1;0;0"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="2.8s"
          begin="0s"
          xlinkHref="#_R_G_L_2_G"
          fill="freeze"
          attributeName="transform"
          from="0 0"
          to="4.6000000000000005 4.6000000000000005"
          type="scale"
          additive="sum"
          keyTimes="0;0.7142857;1"
          values="0 0;4.6000000000000005 4.6000000000000005;4.6000000000000005 4.6000000000000005"
          keySplines="0.001 0 0.227 0.829;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="2.8s"
          begin="0s"
          xlinkHref="#_R_G_L_2_G"
          fill="freeze"
          attributeName="transform"
          from="17.537 -16.537"
          to="17.537 -16.537"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="17.537 -16.537;17.537 -16.537"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="2.8s"
          begin="0s"
          xlinkHref="#_R_G_L_2_G_M"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="0"
          keyTimes="0;0.7142857;0.7142857;1"
          values="1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="2.8s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G"
          fill="freeze"
          attributeName="transform"
          from="0"
          to="0"
          type="rotate"
          additive="sum"
          keyTimes="0;1"
          values="0;0"
          keySplines="0.173 0 0.833 0.923"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="2.8s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G"
          fill="freeze"
          attributeName="transform"
          from="1.1 1.1"
          to="1.1 1.1"
          type="scale"
          additive="sum"
          keyTimes="0;0.5285714;1"
          values="1.1 1.1;1.4000000000000001 1.4000000000000001;1.1 1.1"
          keySplines="0.333 0 0.667 1;0.333 0 0.667 1"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="2.8s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G"
          fill="freeze"
          attributeName="transform"
          from="-45 -45"
          to="-45 -45"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-45 -45;-45 -45"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate attributeType="XML" attributeName="opacity" dur="3s" from="0" to="1" xlinkHref="#time_group" />
      </defs>
      <g id="_R_G">
        <g id="_R_G_L_3_G_M">
          <g id="_R_G_L_3_G" transform=" translate(110, 110)">
            <path
              id="_R_G_L_3_G_D_0_P_0"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              strokeWidth="5"
              strokeOpacity="1"
              d=" M-17.54 -3 C-28.33,-3 -37.07,5.75 -37.07,16.54 C-37.07,27.33 -28.33,36.07 -17.54,36.07 C-6.75,36.07 2,27.33 2,16.54 C2,5.75 -6.75,-3 -17.54,-3z "
            />
          </g>
        </g>
        <g id="_R_G_L_2_G_M">
          <g id="_R_G_L_2_G" transform=" translate(110, 110)">
            <path
              id="_R_G_L_2_G_D_0_P_0"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              strokeWidth="5"
              strokeOpacity="1"
              d=" M-17.54 -3 C-28.33,-3 -37.07,5.75 -37.07,16.54 C-37.07,27.33 -28.33,36.07 -17.54,36.07 C-6.75,36.07 2,27.33 2,16.54 C2,5.75 -6.75,-3 -17.54,-3z "
            />
          </g>
        </g>
        <g id="_R_G_L_1_G" transform=" translate(110, 110) scale(1.31, 1.31) translate(-45, -45)">
          <path
            id="_R_G_L_1_G_D_0_P_0"
            fill="#ffffff"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M45 0 C69.85,0 90,20.15 90,45 C90,69.85 69.85,90 45,90 C20.15,90 0,69.85 0,45 C0,20.15 20.15,0 45,0z "
          />
        </g>
        <g id="_R_G_L_0_G" transform=" translate(110, 110)">
          <path
            id="_R_G_L_0_G_D_0_P_0"
            fill="currentColor"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M64.13 59.13 C63.94,59.21 63.75,59.25 63.57,59.25 C63.17,59.25 62.84,59.1 62.57,58.81 C62.57,58.81 53.57,49.38 53.57,49.38 C53.57,49.38 53.57,53.25 53.57,53.25 C53.57,55.11 52.94,56.7 51.69,58.02 C50.43,59.34 48.91,60 47.14,60 C47.14,60 31.43,60 31.43,60 C29.66,60 28.14,59.34 26.89,58.02 C25.63,56.7 25,55.11 25,53.25 C25,53.25 25,36.75 25,36.75 C25,34.89 25.63,33.3 26.89,31.98 C28.14,30.66 29.66,30 31.43,30 C31.43,30 47.14,30 47.14,30 C48.91,30 50.43,30.66 51.69,31.98 C52.94,33.3 53.57,34.89 53.57,36.75 C53.57,36.75 53.57,40.64 53.57,40.64 C53.57,40.64 62.57,31.2 62.57,31.2 C62.84,30.9 63.17,30.75 63.57,30.75 C63.75,30.75 63.94,30.79 64.13,30.87 C64.71,31.13 65,31.59 65,32.25 C65,32.25 65,57.75 65,57.75 C65,58.41 64.71,58.87 64.13,59.13z "
          />
        </g>
      </g>
      <g id="time_group" />
    </svg>
  )
}
